/** Website news locales. English is unprefixed; every other code is a URL prefix. */

export const NEWS_LOCALES = [
  "en",
  "es",
  "fr",
  "de",
  "it",
  "pt",
  "pt-BR",
  "nl",
  "pl",
  "sv",
  "da",
  "no",
  "fi",
  "cs",
  "sk",
  "sl",
  "hr",
  "hu",
  "ro",
  "el",
  "ca",
  "ru",
  "uk",
  "tr",
  "ar",
  "he",
  "ur",
  "hi",
  "bn",
  "gu",
  "mr",
  "ta",
  "te",
  "pa",
  "ja",
  "ko",
  "zh-Hans",
  "zh-Hant",
  "id",
  "ms",
  "vi",
  "th",
];

export const RTL_LOCALES = new Set(["ar", "he", "ur"]);

const LOCALE_SET = new Set(NEWS_LOCALES);

export function isNewsLocale(value) {
  return LOCALE_SET.has(String(value || ""));
}

export function localePath(locale, path = "") {
  const suffix = path ? `/${String(path).replace(/^\/+/, "")}` : "";
  if (!locale || locale === "en") return `/news${suffix}`;
  return `/${locale}/news${suffix}`;
}
